import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";

export class UserFileService extends AbstractApiService {
    constructor() {
        super();
    }
    
    public GetMyCertifications(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/userfile/getmycertifications', onSuccess, onError);
    }

    public GetPhysiotherapistsCertifications(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/userfile/getphysiotherapistscertifications?physiotherapistId=' + physiotherapistId, onSuccess, onError);
    }

    public DeleteMyFile(fileId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/userfile/deletemyfile', fileId, onSuccess, onError);
    }

    public GetMyPictures(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/userfile/getmypictures', onSuccess, onError);
    }

    public GetPhysiotherapistsPictures(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/userfile/getphysiotherapistspictures?physiotherapistId=' + physiotherapistId, onSuccess, onError);
    }

    public ProcessImages(fileIds: number[], onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/userfile/processimages', fileIds, onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/UserFileService.tsx